import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

class MultiCombo extends React.Component {
	constructor(props) {
		super(props);
		this.state = this._buildState(props);
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === null || this.state.value.length === 0) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_buildState = (props) => {
        let valueArr = [];
        let selected = [];
        const value = props.value;
        const options = this._getOptions(props.items);

        // We shall receive an array or a string (comma separated) as value.
        if (value instanceof Array) {
            valueArr = value;
        }
        else if (typeof value === 'string' || value instanceof String) {
            if (value.indexOf(",") > 0)
                valueArr = value.replace(" ", "").split(",");
        }

        // Fetch selected values from the option list
        if (valueArr.length !== 0) {
            selected = options.filter(x => valueArr.includes(x.value));

            // Didn't find selected values? Try parsing the number
            if (selected.length === 0)
                selected = options.filter(x => valueArr.includes(parseInt(x.value, 10)));

            // Didn't find selected values? Try converting to string
            if (selected.length === 0)
                selected = options.filter(x => valueArr.includes(x.value.toString && x.value.toString()));
        }

		return {
			className: this._className(),
			value: valueArr,
			selected: selected,
			options: options
		};
	}

	_getOptions = (items) => {
		// It's an array coming, return that one..
		if (items instanceof Array)
			return items;

		let options = [];

		for (var c in items)
			options.push({ value: c, label: items[c] });

		return options;
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

    _handleChange = (item) => {
        this._update(item);
    }

	_update = (item) => {
		const me = this;
		let value = [];

		if (item !== null) {
            value = item.map(i => i.value);
		}

		this.setState({
			value: value
		}, () => {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();

			// Update value field in form
			if (me.props.managed)
				this.props.onFieldChange(value, this.props.name, () => { me.onChange(item); });
			else
				this.onChange(item);
		});
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextProps.items !== this.props.items
			|| nextState.className !== this.state.className);
	}

	componentWillReceiveProps(nextProps, nextState) {
		if (nextProps.value !== this.props.value ||
			nextProps.items !== this.props.items)
			this.setState(this._buildState(nextProps));
	}

	render() {
		const props = {
            isMulti: true,
			id: this.props.id,
			name: this.props.name,
			value: this.state.selected,
			onChange: this._handleChange,
			placeholder: this.props.placeholder,
			options: this.state.options,
			className: this.state.className,
			menuStyle: { height: this.props.menuHeight },
			isDisabled: this.props.disabled,
			isSearchable: this.props.searchable,
			isClearable: this.props.clearable
		};

		const customStyles = {
			container: (base, state) => {
				if (!state.isDisabled) {
					return {
						...base,
						backgroundColor: "transparent",
					};
                } else {
					return {
						...base,
						backgroundColor: "#eee",
                    };
                 }
            },
			singleValue: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#555"
			}),
			placeholder: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#AAA"
			}),
			input: (provided, state) => ({
				...provided,
				marginTop: -2,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			indicatorsContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer'
			}),
			control: (provided, state) => ({
				...provided,
                minHeight: 34,
				boxShadow: 0,
				borderRadius: 0
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0,
				zIndex: "999 !important"
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			}),
			dropdownIndicator: (base, state) => ({
				...base,
				width: '30px',
                paddingTop: 0,
                paddingBottom: 0
			}),
			clearIndicator: (base, state) => ({
				...base,
				width: '30px',
				marginRight: '-15px',
                paddingTop: 0,
                paddingBottom: 0
			}),
			menuContainerStyle: () => ({
				zIndex: "999 !important"
			})
		}

		return (
			<Select {...props}
				styles={customStyles}
                components={ makeAnimated() }
				ref={(select) => { this.select = select; }} />)

	}
}

// Mark this as a form component
MultiCombo.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false
};

export default MultiCombo;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/multiCombo/MultiCombo.js